import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { inject } from '@ember/service';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<div class=\'grid-content online-users\' ...attributes>\n  <span class=\'beebeeLabel\'>\n    {{t \'online user\'}}\n  </span>\n\n  <ul class=\'online-users-list\' role=\'list\'>\n    {{#each @users as |user|}}\n      <li class=\'grid-x\'>\n        <div class=\'cell medium-3 small-3\'>\n          <BbThumbnail @size={{48}} @thumbnail_size=\"small\" @item={{user}} class=\"avatar avatar-sm\" @applicationController={{@applicationController}}></BbThumbnail>\n        </div>\n        <div class=\'cell auto\'>\n          <div class=\'name beebeeLabel\' aria-label={{user.label}}>\n            {{user.label}}\n          </div>\n\n          <BbUserPlatform @user={{user}} />\n\n          <BbUserBrowser @user={{user}} />\n\n          <small class=\'float-right\'>\n            <BbTimeAgo\n              @time_zone={{this.session.me.time_zone}}\n              @date={{user.last_login}}\n            />\n          </small>\n        </div>\n      </li>\n    {{/each}}\n  </ul>\n</div>\n");

var _class, _descriptor;
let BbPresenceIndicatorComponent = (_class = class BbPresenceIndicatorComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "session", _descriptor, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
setComponentTemplate(TEMPLATE, BbPresenceIndicatorComponent);

export { BbPresenceIndicatorComponent as default };
//# sourceMappingURL=bb-presence-indicator.js.map
